module.exports = __webpack_public_path__ + "static/media/CC3-2.243e8f36.jpg";